"use strict";
var DefaultColorLabel = /* @__PURE__ */ ((DefaultColorLabel2) => {
  DefaultColorLabel2["White"] = "#FFFFFF";
  DefaultColorLabel2["Grey10"] = "#F2F6F7";
  DefaultColorLabel2["Grey25"] = "#E0E8EC";
  DefaultColorLabel2["Midnight"] = "#242C39";
  DefaultColorLabel2["Grey"] = "#81A2B2";
  return DefaultColorLabel2;
})(DefaultColorLabel || {});
export const DEFAULT_WHITE = {
  value: "#FFFFFF" /* White */,
  themeIndex: -1
};
export const DEFAULT_GREY10 = {
  value: "#F2F6F7" /* Grey10 */,
  themeIndex: -2
};
export const DEFAULT_MIDNIGHT = {
  value: "#242C39" /* Midnight */,
  themeIndex: -3
};
export const DEFAULT_GREY = {
  value: "#81A2B2" /* Grey */,
  themeIndex: -4
};
export const DEFAULT_GREY25 = {
  value: "#E0E8EC" /* Grey25 */,
  themeIndex: -5
};
const defaultColors = [DEFAULT_MIDNIGHT, DEFAULT_GREY10, DEFAULT_WHITE];
export const defaultBorderColors = [DEFAULT_GREY, DEFAULT_MIDNIGHT, DEFAULT_WHITE];
export const allDefaultColors = [
  DEFAULT_GREY25,
  DEFAULT_GREY,
  DEFAULT_MIDNIGHT,
  DEFAULT_GREY10,
  DEFAULT_WHITE
];
export default defaultColors;
